export default __webpack_public_path__ + "static/media/lds-logo_nl.9a8c45dac2493dea.svg";